import React from "react";
import PropTypes from "prop-types";
import { Form, Input, Space, Button } from "antd";
import styled from "styled-components";
import { SearchOutlined } from "@ant-design/icons";

const StyledFormItem = styled(Form.Item)`
  .ant-form-item-label > label {
    color: #fff !important;
  }
`;

const StyledInput = styled(Input)`
  background-color: #1f1f1f !important;
  border-color: #434343 !important;
  color: #fff !important;

  &::placeholder {
    color: rgba(255, 255, 255, 0.3) !important;
  }

  &:hover,
  &:focus {
    border-color: #177ddc !important;
  }
`;

const AOE2_RESOURCES_SHAPE = PropTypes.shape({
  url: PropTypes.string.isRequired,
  icon: PropTypes.string.isRequired,
  alt: PropTypes.string.isRequired,
});

const StyledButton = styled(Button)`
  &.ant-btn {
    background-color: #1f1f1f;
    border-color: #434343;
    border-radius: 4px;
    padding: 8px;
    color: #fff;

    &:hover {
      background-color: #262626;
      border-color: #434343;
      color: #fff;
    }

    img {
      width: 24px;
      height: 24px;
      object-fit: contain;
    }
  }
`;

const formItemLayout = {
  labelCol: { span: 24 },
  wrapperCol: { span: 24 },
};

const UserFormFields = ({
  editedRegistration,
  onInputChange,
  AOE2_RESOURCES,
  setOpenPopup,
}) => {
  return (
    <Form
      {...formItemLayout}
      style={{
        width: "100%",
        color: "#fff",
      }}
    >
      <StyledFormItem label="Username">
        <StyledInput
          name="username"
          value={editedRegistration.username || ""}
          onChange={onInputChange}
          placeholder="Ingrese username"
        />
      </StyledFormItem>
      <StyledFormItem label="Old User ID">
        <StyledInput
          name="oldUserId"
          value={editedRegistration.oldUserId || ""}
          onChange={onInputChange}
          placeholder="Ingrese old user ID"
        />
      </StyledFormItem>
      <StyledFormItem label="Email">
        <StyledInput
          name="email"
          value={editedRegistration.email || ""}
          onChange={onInputChange}
          placeholder="Ingrese email"
          type="email"
        />
      </StyledFormItem>
      <StyledFormItem label="AoE2 Profile ID">
        <StyledInput
          name="aoe2ProfileId"
          value={editedRegistration.aoe2ProfileId || ""}
          onChange={onInputChange}
          placeholder="Ingrese AoE2 profile ID"
        />
      </StyledFormItem>
      <Space direction="vertical" size="middle" style={{ width: "100%" }}>
        <Space
          size="middle"
          wrap
          style={{ marginTop: "16px", justifyContent: "center" }}
        >
          {AOE2_RESOURCES.map((resource) => (
            <StyledButton
              key={resource.url}
              type="text"
              href={`${resource.url}${editedRegistration.aoe2ProfileId}`}
              target="_blank"
              icon={
                <img
                  src={`https://alexocampos.github.io/liga-espanhola-aoe2-static/assets/${resource.icon}`}
                  alt={resource.alt}
                  title={resource.alt}
                />
              }
            />
          ))}
          <Button
            onClick={() => setOpenPopup(true)}
            style={{
              background: "#722ed1",
              borderColor: "#722ed1",
              color: "#fff",
              width: "100%",
            }}
            icon={<SearchOutlined />}
          >
            Ver info AoE2
          </Button>
        </Space>
      </Space>
    </Form>
  );
};

UserFormFields.propTypes = {
  editedRegistration: PropTypes.shape({
    username: PropTypes.string,
    oldUserId: PropTypes.string,
    email: PropTypes.string,
    aoe2ProfileId: PropTypes.string,
  }).isRequired,
  onInputChange: PropTypes.func.isRequired,
  AOE2_RESOURCES: PropTypes.arrayOf(AOE2_RESOURCES_SHAPE).isRequired,
  setOpenPopup: PropTypes.func.isRequired,
};

export default UserFormFields;
